import { reactive, toRefs } from 'vue';
import Api from '../api/Payment';

const initialState = {
    is_active: false,
    in_progress: false,
    order_id: null,
    amount: 0,
    title: '',
    title_class: '',
    description: '',
    try_again_btn: false,
    go_to_account_btn: false,
    maxAttempts: 100,
    currentAttempt: 1,
    secondsBetweenEachCheck: 3
};

const state = reactive({ ...initialState });

export default {
    state: toRefs(state),
    init(initResponse) {
        state.is_active = true;
        state.in_progress = true;
        if (initResponse && initResponse.transaction) {
            state.order_id = initResponse.transaction;
            state.amount = initResponse.amount;
        }

        this.checkPaymentStatus(state.currentAttempt);
    },
    setIsActive(val) {
        state.is_active = val;
    },
    setInProgress(val) {
        state.in_progress = val;
    },
    checkPaymentStatus() {
        Api.GetVippsTransactionStatus({
            attempt: state.currentAttempt,
            max: state.maxAttempts
        }).then(res => {
            this.setVippsData(res.data);
            state.currentAttempt++;
            if (state.in_progress) {
                const _this = this;
                setTimeout(function () {
                    _this.checkPaymentStatus();
                }, _this.state.secondsBetweenEachCheck * 1000);
            }
        });
    },
    setVippsData(data) {
        state.in_progress = data.inprogress;
        state.try_again_btn = data.try_again_btn;
        state.go_to_account_btn = data.to_account_btn;
        state.description = data.description;
        state.title = data.title;
        state.title_class = data.title_class;
        if (data.amount) {
            state.amount = data.amount;
        }
        if (data.order_id) {
            state.order_id = data.order_id;
        }
    },
    reset() {
        state.is_active = false;
        state.in_progress = false;
        state.amount = 0;
        state.title = '';
        state.title_class = '';
        state.description = '';
        state.try_again_btn = false;
        state.go_to_account_btn = false;
        state.currentAttempt = 1;
    },
    getOrderId() {
        return state.order_id;
    },
    getInProgress() {
        return state.in_progress;
    },
    getAmount() {
        return state.amount;
    },
    getTitle() {
        return state.title;
    },
    getTitleClass() {
        return state.title_class;
    },
    getDescription() {
        return state.description;
    },
    getTryAgainButton() {
        return state.try_again_btn;
    },
    getGoToAccountButton() {
        return state.go_to_account_btn;
    },
    getIsActive() {
        return state.is_active;
    },
};
